import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const renew: IMcAppType = {
  name: "renew_SAP",
  path: "/my-account/renew-plan",
  description: "Renew existing service agreements",
  navFlow: NavFlow.FOCUS,
  title: "Renew",
  parent: Tab.MORE,
  conditions: {
    intent: "renew",
    customerType: CustomerType.sap,
  },
};
